<script>
export default {
  methods: {
    showNotificacao (type, title, msg, timeout = 5000, position = 'toast-top-right') {
      this.$toastr(type, {
        title,
        msg,
        clickClose: true,
        timeout,
        position
      })
    },
    confirmBox (msg, title, callback, error, confirmButtonText = 'Confirmar', cancelButtonText = 'Cancelar', type = 'warning') {
      this.$confirm(msg, title, {
        confirmButtonText,
        cancelButtonText,
        type
      })
        .then(callback)
        .catch(error)
    }
  }
}
</script>
